export const FETCH_TEMPLATES = "FETCH_TEMPLATES";
export const FETCH_TEMPLATES_SUCCESS = "FETCH_TEMPLATES_SUCCESS";
export const FETCH_TEMPLATES_FAILURE = "FETCH_TEMPLATES_FAILURE";

export const FETCH_TEMPLATE = "FETCH_TEMPLATE";
export const FETCH_TEMPLATE_SUCCESS = "FETCH_TEMPLATE_SUCCESS";
export const FETCH_TEMPLATE_FAILURE = "FETCH_TEMPLATE_FAILURE";

export const DELETE_TEMPLATE = "DELETE_TEMPLATE";
export const DELETE_TEMPLATE_SUCCESS = "DELETE_TEMPLATE_SUCCESS";
export const DELETE_TEMPLATE_FAILURE = "DELETE_TEMPLATE_FAILURE";

export const CREATE_TEMPLATE = "CREATE_TEMPLATE";
export const CREATE_TEMPLATE_SUCCESS = "CREATE_TEMPLATE_SUCCESS";
export const CREATE_TEMPLATE_FAILURE = "CREATE_TEMPLATE_FAILURE";

export const UPDATE_TEMPLATE = "UPDATE_TEMPLATE";
export const UPDATE_TEMPLATE_SUCCESS = "UPDATE_TEMPLATE_SUCCESS";
export const UPDATE_TEMPLATE_FAILURE = "UPDATE_TEMPLATE_FAILURE";

export const CLEAR_TEMPLATE = "CLEAR_TEMPLATE";

export const FETCH_TEMPLATE_CATEGORIES = "FETCH_TEMPLATE_CATEGORIES";
export const FETCH_TEMPLATE_CATEGORIES_SUCCESS =
  "FETCH_TEMPLATE_CATEGORIES_SUCCESS";
export const FETCH_TEMPLATE_CATEGORIES_FAILURE =
  "FETCH_TEMPLATE_CATEGORIES_FAILURE";

export const FETCH_TEMPLATE_BY_CATEGORY = "FETCH_TEMPLATE_BY_CATEGORY";
export const FETCH_TEMPLATE_BY_CATEGORY_SUCCESS =
  "FETCH_TEMPLATE_BY_CATEGORY_SUCCESS";
export const FETCH_TEMPLATE_BY_CATEGORY_FAILURE =
  "FETCH_TEMPLATE_BY_CATEGORY_FAILURE";

export const FETCH_SINGLE_TEMPLATE_BY_CATEGORY =
  "FETCH_SINGLE_TEMPLATE_BY_CATEGORY";
export const FETCH_SINGLE_TEMPLATE_BY_CATEGORY_SUCCESS =
  "FETCH_SINGLE_TEMPLATE_BY_CATEGORY_SUCCESS";
export const FETCH_SINGLE_TEMPLATE_BY_CATEGORY_FAILURE =
  "FETCH_SINGLE_TEMPLATE_BY_CATEGORY_FAILURE";

export const FETCH_TEMPLATE_BY_CATEGORY_SUBCATEGORY =
  "FETCH_TEMPLATE_BY_CATEGORY_SUBCATEGORY";
export const FETCH_TEMPLATE_BY_CATEGORY_SUBCATEGORY_SUCCESS =
  "FETCH_TEMPLATE_BY_CATEGORY_SUBCATEGORY_SUCCESS";
export const FETCH_TEMPLATE_BY_CATEGORY_SUBCATEGORY_FAILURE =
  "FETCH_TEMPLATE_BY_CATEGORY_SUBCATEGORY_FAILURE";
